<template>
  <div class="cart-item bacwhite">
    <!-- 购物车 -->
    <div class="chead flex_b">
      <Iconfont
        :name=" selected  ? 'iconselected' : 'iconweixuanzhong'"
        size="0.6rem"
        :color=" selected ? '#FD3E3E' : '#999'"
        v-if="cart"
        @click="selectGood"
      ></Iconfont>
      <div class="right flex" :style="{ width: cart ? '90%' : '100%' }">
        <div class="imgwrap">
          <img :src="info.goods_image" class="rimg" />
          <div class="invalid" v-if="info.error_code > 0 "></div>
        </div>

        <div class="good-spec">
          <div class="gname">{{ info.goods_name }}</div>
          <div class="gspec">{{ info.spec_name }}</div>
          <div class="jifen flex">
            <div class="jfleft flex">
              <span class="jfinfo">{{ info.jinbi }}</span>
              <b
                style="padding: 0 0.1rem;font-size: 0.4rem;border: 1px solid #fd3e3e;border-radius:0.5rem"
              >积分</b>
            </div>
            <span class="gnum">x{{ info.buy_num }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="caddress flex" v-if="cart" @click="openAddress">
      <Iconfont name="icondingwei" size="0.6rem" color="#999"></Iconfont>
      <div class="adtip">{{ address }}</div>
      <Iconfont name="iconyou" size="0.5rem" color="#999"></Iconfont>
    </div>
    <div class="caddress" v-if="!cart && goodsType != 2">
      <p class="add_user_msg">{{ info.receipt_name }}{{ info.mobile }}</p>
      <div class="flex">
        <Iconfont name="icondingwei" size="0.6rem" color="#999"></Iconfont>
        <div class="adtip">{{ address }}{{ adr_info }}</div>
      </div>
    </div>
    <div class="express flex" v-if="goodsType != 2 && cart" @click="changeMode">
      <div class="express-style">
        <span class="color9">运输方式</span>
        <span class="kg">{{ info.yf_mode_name }}</span>
      </div>
      <div class="express-style">
        <Iconfont class="fr" name="iconyou" style="margin-top: 0.1rem;" size="0.5rem" color="#999"></Iconfont>

        <div class="fr" v-if="info.if_free_shipping == '0' && info.is_calc_freight == 1">
          <span>{{ info.freight_format }}元</span>
        </div>
        <div class="fr" v-if="info.if_free_shipping == '1'">
          <span>{{info.free_shipping}}</span>
        </div>
        <div class="fr" v-if="info.if_free_shipping == '0' && info.is_calc_freight != 1">
          <span class="color9" v-if="info.freight_payer ==1">
            (预估):
            {{info.freight_format}}元
          </span>
          {{info.free_shipping}}
        </div>
      </div>
    </div>

    <!-- 订单 -->
    <div class="express flex" v-if="goodsType != 2 && !cart">
      <div class="express-style">
        <span class="color9">运输方式</span>
        <span class="kg">{{ info.yf_mode_name }}</span>
      </div>
      <div class="express-style">
        <div class="fr" v-if="info.if_free_shipping == '0' && info.is_calc_freight == 1">
          <span>{{ info.freight_format }}元</span>
        </div>
        <div class="fr" v-if="info.if_free_shipping == '1'">
          <span>{{info.free_shipping}}</span>
        </div>
        <div class="fr" v-if="info.if_free_shipping == '0' && info.is_calc_freight != 1">
          <span class="color9" v-if="info.freight_payer ==1">
            (预估):
            {{info.freight_format}}元
          </span>
          {{info.free_shipping}}
        </div>
      </div>
    </div>

    <div v-if="info.error_code > 0 && goodsType != 2  " class="error_top flex">
      <Iconfont name="icongantanhao-copy" class="icon" size="0.5rem" color="#FD3E3E"></Iconfont>
      <span>{{ info.error }}</span>
    </div>

    <van-popup v-model="show" position="bottom">
      <div class="popup-content">
        <div class="flex_b phead">
          <span>请选择地址</span>
          <iconfont name="iconx" size="1rem" color="#333" @click="show = false"></iconfont>
        </div>
        <div class="address-center">
          <div class="acenter flex_b" v-for="item in addressList" :key="item.addr_id">
            <iconfont
              @click="saddress = item.addr_id"
              :name="
                saddress == item.addr_id ? 'iconselected' : 'iconweixuanzhong'
              "
              size="0.68rem"
              :color="saddress == item.addr_id ? '#FD3E3E' : '#999'"
            ></iconfont>
            <div class="aright">
              <div class="ahead">{{ item.consignee }} {{ item.phone_mob }}</div>
              <div class="ainfo">{{ item.region_name }}</div>
            </div>
          </div>
        </div>
        <div class="cbutton" @click="confim">确定</div>
      </div>
    </van-popup>

    <van-popup v-model="modeshow" position="bottom">
      <div class="popup-content">
        <div class="flex_b phead">
          <span>请选择配送方式</span>
          <iconfont name="iconx" size="1rem" color="#333" @click="modeshow = false"></iconfont>
        </div>
        <div class="flex center">
          <div
            :class="{
              expressOptioned: item.code == yf_mode,
              expressOption: item.code != yf_mode,
            }"
            @click="yf_mode = item.code"
            :key="item.code"
            v-for="item in modes"
          >{{ item.name }}</div>
        </div>
        <div class="cbutton" @click="confim">确定</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Iconfont from '@/components/iconfont.vue'
import { sendRequest } from '@/assets/public'
import { Toast, Dialog } from 'vant'
export default {
  name: 'cartItem',
  components: { Iconfont },
  props: {
    goodsType: {
      type: String,
      default: '',
    },
    cart: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    info: {
      type: Object,
      default() {
        return {}
      },
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      addressList: [],
      selected: false,
      saddress: '',
      address: '',
      modes: [],
      modeshow: false,
      yf_mode: '',
      adr_info: '',
    }
  },
  created() {
    this.saddress = this.info.addr_id
    this.address = this.info.region_name
    this.selected = this.info.selected
    this.yf_mode = this.info.yf_mode
    this.init_yf_mode = this.info.yf_mode
    this.adr_info = this.info.address
  },
  watch: {
    modeshow: function (e, a) {
      if (!e && a) {
        setTimeout(() => {
          this.yf_mode = this.init_yf_mode
        }, 500)
      }
    },
    isEdit: function () {
      console.log(
        this.isEdit && this.info.error_code > 0 && this.cart && this.selected
      )
      if (
        this.isEdit &&
        this.info.error_code > 0 &&
        this.cart &&
        this.selected
      ) {
        this.selectGood(true)
      }
    },
  },
  methods: {
    //确认修改物流方式
    async confim() {
      if (!this.yf_mode) {
        Toast('请先选择配送方式')
        return
      }
      let { status, msg } = await sendRequest('cart/add', {
        edit: 1,
        id: this.cart ? this.info.stock_id : this.info.id,
        addr_id: this.saddress,
        num: this.info.buy_num,
        yf_mode: this.yf_mode,
      })
      if (status != 200) {
        Toast(msg)
        return
      }

      this.$emit('set', true)
      this.modeshow = false
      this.show = false
    },
    async changeMode() {
      let { content } = await sendRequest('goods/getYfMode', {
        addr_id: this.saddress,
        xhq_id: this.info.stock_id,
      })
      let tarr = []
      let obj = content ? content.yf_mode : {}
      for (let item in obj) {
        for (let items in obj[item]) {
          console.log(items)
          tarr.push(obj[item][items])
        }
      }
      console.log(tarr)
      this.modes = tarr
      if (this.modes.length > 0) {
        this.modeshow = true
      }
    },

    //选择商品
    selectGood(iskey) {
      if (!iskey && this.isEdit && this.info.error_code > 0) {
        return
      }
      this.selected = !this.selected
      let nobj = this.info
      nobj.selected = this.selected
      this.$emit('selectSingleGood', { index: this.index, info: nobj })
    },
    //打开地址
    async openAddress() {
      let { content } = await sendRequest('user/addrList', { limit: 10000 })
      this.addressList = content ? content.data : []
      this.show = true
    },
  },
}
</script>

<style scoped>
.add_user_msg {
  color: #121c27;
  font-size: 0.56rem;
  margin-bottom: 0.4rem;
}

.cart-item {
  width: calc(100% - 1.6rem);
  padding: 0.4rem 0.8rem 0.52rem 0.8rem;
  margin-top: 0.4rem;
}

.chead {
  width: 100%;
  padding-bottom: 0.48rem;
  border-bottom: 1px solid #ddd;
  align-items: center;
}

.right {
  justify-content: space-between;
}

.imgwrap {
  width: 2.8rem;
  height: 2.8rem;
  position: relative;
}

.rimg {
  width: 2.8rem;
  height: 2.8rem;
}

.invalid {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 0.52rem;
  line-height: 2.8rem;
  text-align: center;
}

.good-spec {
  width: calc(100% - 3.2rem);
}

.gname {
  font-size: 0.56rem;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.gspec {
  margin-top: 0.48rem;
  font-size: 0.48rem;
  color: #999;
}

.jifen {
  width: 100%;
  margin-top: 0.68rem;
  justify-content: space-between;
  align-items: center;
}

.jfleft {
  color: #fd3e3e;
  font-size: 0.4rem;
  align-items: center;
}

.jtip {
  border: 1px solid #fd3e3e;
  text-align: center;
  line-height: 0.56rem;
  font-size: 0.4rem;
  width: 1.4rem;
  margin-left: 0.2rem;
  border-radius: 0.28rem;
}

.jfinfo {
  font-size: 0.72rem;
  font-weight: bold;
}

.gnum {
  font-size: 0.56rem;
}

.caddress {
  width: 100%;
  padding: 0.6rem 0;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
  align-items: center;
}

.adtip {
  width: 12rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.52rem;
}

.express {
  width: 100%;
  justify-content: space-between;
  padding-top: 0.52rem;
  font-size: 0.52rem;
}

.express-style .kg {
  margin-left: 0.3rem;
}

.phead {
  font-size: 0.6rem;
}

.popup-content .center {
  margin-top: 1.8rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.expressOptioned {
  min-width: 2.66rem;
  height: 0.96rem;
  text-align: center;
  line-height: 0.96rem;
  font-size: 0.48rem;
  color: #fff;
  border-radius: 0.2rem;
  background: #fd3e3e;
  border: 1px solid #fd3e3e;
  margin-right: 0.3rem;
  margin-bottom: 0.3rem;
  padding: 0 0.2rem;
  box-sizing: border-box;
}

.expressOption {
  min-width: 2.66rem;
  height: 0.96rem;
  text-align: center;
  line-height: 0.96rem;
  font-size: 0.48rem;
  color: #999;
  border: 1px solid #ddd;
  border-radius: 0.2rem;
  margin-right: 0.3rem;
  margin-bottom: 0.3rem;
  padding: 0 0.2rem;
  box-sizing: border-box;
}

.cbutton {
  width: 13.6rem;
  border-radius: 0.2rem;
  text-align: center;
  line-height: 2rem;
  color: #fff;
  font-size: 0.6rem;
  background: #fd3e3e;
}

.popup-content {
  width: calc(100% - 1.4rem);
  padding: 0.6rem 0.7rem 0.8rem 0.7rem;
}

.acenter {
  padding: 0.8rem 0;
  border-bottom: 1px solid #ddd;
  align-items: center;
}

.aright {
  width: 12rem;
}

.aright .ahead {
  font-size: 0.56rem;
}

.aright .ainfo {
  font-size: 0.48rem;
  color: #999;
  margin-top: 0.4rem;
}

.address-center {
  width: 100%;
  max-height: 5rem;
  overflow-y: scroll;
  margin: 0.5rem 0;
}

.error_top {
  padding: 0.6rem 0 0;
  margin-top: 0.52rem;
  border-top: 1px solid #ddd;
  color: #fd3e3e;
  font-size: 0.44rem;
}

.error_top .icon {
  margin-top: 0.05rem;
}

.error_top span {
  margin-left: 0.4rem;
}
</style>